require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/registrer/CubeVideosModule.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/registrer/CubeVideosModule.legacy.js
// module id = 726
// module chunks = 31